import React from 'react';
import { useReveal } from '../lib/useReveal';
const ACTIVITIES = [{
  title: 'Senderismo',
  description: 'Caminatas accesibles por senderos marcados. El mejor espacio para construir tus primeras experiencias.',
  icon: '🌿'
}, {
  title: 'Trekking',
  description: 'Excursiones más largas con mayor desnivel, autonomía y planificación.',
  icon: '🥾'
}, {
  title: 'Alta montaña',
  description: 'Cumbres con nieve o hielo que requieren técnica, equipo específico y formación adicional.',
  icon: '🏔️'
}, {
  title: 'Escalada',
  description: 'Una actividad vertical que requiere técnica, equipo homologado y formación específica antes de empezar.',
  icon: '🧗'
}];
export function CareerSection() {
  const [ref, visible] = useReveal();
  return <section className="border-t border-white/5 bg-[#17231c] px-4 py-14 md:py-20" data-id="element-59" data-mp="2ygsyhgxy8jn8">
      <div ref={ref} className={`reveal container mx-auto max-w-5xl ${visible ? 'is-visible' : ''}`} data-id="element-60" data-mp="20z18vo6z3v25">
        <div className="mx-auto mb-10 max-w-3xl text-center" data-id="element-61" data-mp="25xm5ldn0nwlu">
          <p className="mb-4 text-sm font-bold uppercase tracking-[0.22em] text-[#e6a45c]" data-id="element-62" data-mp="1t1pw0kntln2d">Empezá donde corresponde</p>
          <h2 className="mb-4 font-serif text-3xl font-bold text-white md:text-5xl" data-id="element-63" data-mp="1o34t2dh6opa8">No toda montaña se camina igual.</h2>
          <p className="text-lg leading-relaxed text-stone-400" data-id="element-64" data-mp="1j9txx9lqhwy5">Entender qué tipo de actividad estás haciendo cambia cómo te preparás, qué llevás y cuándo es momento de sumar experiencia.</p>
        </div>
        <div className="grid gap-5 sm:grid-cols-2 xl:grid-cols-4" data-id="element-65" data-mp="1ac9q1htd92ek">
          {ACTIVITIES.map(activity => <article key={activity.title} className="rounded-2xl border border-white/10 bg-[#101914] p-7" data-id="element-66" data-mp="15a106ubsiggo">
            <span className="mb-5 block text-3xl" data-id="element-67" data-mp="10cso9bh8j8nv">{activity.icon}</span>
            <h3 className="mb-3 font-serif text-2xl font-bold text-white" data-id="element-68" data-mp="wbyyeck8fjsc">{activity.title}</h3>
            <p className="leading-relaxed text-stone-400" data-id="element-69" data-mp="2upila22wgxzh">{activity.description}</p>
          </article>)}
        </div>
        <p className="mt-8 text-center font-serif text-xl font-semibold text-[#dbe8d5]" data-id="element-70" data-mp="2qpgh9m9ozsh1">El programa te ayuda a empezar con bases sólidas; la alta montaña requiere formación técnica adicional.</p>
      </div>
    </section>;
}